import React, { useState } from 'react'
import FileUpload from './form/FileUpload'
import ModalActionButton from './ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { authHeader } from '../../utils';
import { ERROR } from '../../store/types';
import { submitRequestedDocument } from '../../store/actions/documentRequestActions';

const UploadRequestedDocument = ({documentDetails, closeFunction}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [validationErrors, setValidationErrors] = useState(false);

  const dispatch = useDispatch()
  const documentRequestsSelector = useSelector(state => state.documentRequests)

 
  const validateForm = () => {
    let errors = {}


    if(!file) {
        errors.file = true
    }


    setValidationErrors(errors)

    return errors
  }

  const handleUpload = async () => {
    if (Object.values(validateForm()).includes(true)) {
      dispatch({
          type: ERROR,
          error: {response: {data: {
              message: 'Please check the highlighted fields'
          }}}
      })
      return
    }
    
    var formData = new FormData()
    formData.append('file', file.file )
    const headers = new Headers();
    headers.append("Authorization",  authHeader().Authorization);
    setUploading(true)
    try {
        const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
            method: "POST",
            headers,
            body: formData,
        });
        const uploaded = await doUpload.json();
        
        dispatch(submitRequestedDocument(documentDetails._id, {
          documentUrl: uploaded.data.file
        }))
        setUploading(false)

    } catch (error) {
        dispatch({
            type: ERROR,
            error,
        });
    }
  }
  

  return (
    <>
      <p className='text-sm mb-[10px]'>{documentDetails.name}</p>
      <p className='text-sm mb-[10px]'>{documentDetails.description}</p>
      <div className='w-full'>
          <FileUpload
              hasError={validationErrors && validationErrors.file}
              fieldLabel={`Upload ${documentDetails.name}`}
              returnFileDetails={(details)=>{
                  setFile(details)
              }}
              acceptedFormats={['pdf', 'jpeg', 'jpg', 'png']}
          />
          <label className='block mt-3 text-xs text-gray-400'>{`Recent passport photograph of the applicant`}</label>
      </div>

      <div className="mt-8 flex flex-row-reverse gap-x-4">
          <ModalActionButton
              buttonLabel={`Upload ${documentDetails?.name}`}
              buttonAction={()=>{handleUpload()}}
              processing={uploading || documentRequestsSelector.updatingDocumentRequest}
          />

          <button
            type="button"
            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
            onClick={closeFunction}
          >
              Close
          </button>
          
      </div>
    </>
  )
}

export default UploadRequestedDocument